import { render, staticRenderFns } from "./DetailWithdrawSell.vue?vue&type=template&id=22563839"
import script from "./DetailWithdrawSell.vue?vue&type=script&lang=js"
export * from "./DetailWithdrawSell.vue?vue&type=script&lang=js"
import style0 from "./DetailWithdrawSell.vue?vue&type=style&index=0&id=22563839&prod&lang=css"
import style1 from "./DetailWithdrawSell.vue?vue&type=style&index=1&id=22563839&prod&lang=css"
import style2 from "spinkit/scss/spinkit.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports